import React from 'react';
import { hot } from 'react-hot-loader/root';
import EventMapProvider from '../../context/EventMapContext';
import EventsPage from '../Events/EventsPage';
import ErrorBoundary from '../ErrorBoundary';

function EventMapContainer() {
  return (
    <ErrorBoundary>
      <EventMapProvider>
        <EventsPage />
      </EventMapProvider>
    </ErrorBoundary>
  );
}

export default hot(EventMapContainer);
